<template>
  <div class="sfwaitpay">
    <div class="myspespace"></div>
    <div class="sp1"></div>
    <div class="searchlist1">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div class="left">
            <div class="leftin">
              <div class="l1">
                <span class="s1">满减券</span>
                {{item.coupon.title}}
              </div>
              <div class="l2">有效期：{{item.begin_date}} - {{item.end_date}}</div>
              <div class="l3">详细信息：{{item.description}}</div>
            </div>
          </div>
          <div class="right">
            <div class="r1">￥{{(parseInt(item.coupon.reduce_cost)/100).toFixed(2)}}</div>
            <div class="r2">满{{(parseInt(item.coupon.least_cost)/100).toFixed(2)}}可用</div>
            <div class="r3" @click="gotoUse(item.coupon)">
              <div class="r3btn">去使用</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getUserCardList } from '@/api/modules/user'
export default {
  name: 'sfwaitpay',
  components: {
  },
  data() {
    return {
      loading: false,
      finished: false,
      dataList: [],
      searchOptions: {
        'status': '1',
        'company_id': '1',
        'scope_type': 'sf'
      },
      searchPage: {
        'page': 0,
        'pageSize': 10
      }
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    onLoad() {
      this.searchPage.page++
      this.loadData()
    },
    loadData() {
      const params = Object.assign({}, this.searchPage, this.searchOptions)
      getUserCardList(params).then((res) => {
        if (res.data.status_code === 200) {
          res.data.list.forEach((item) => {
            item.loading = false
          })
          this.dataList.push(...res.data.list)
          // 这里表示最后一页
          if (this.searchPage.page * this.searchPage.pageSize >= res.data.total_count || res.data.list.length === 0) {
            this.loading = true
            this.finished = true
          }
          else {
            this.finished = false
            this.loading = false
          }
        }
      })
    },
    gotoUse(item) {
      if (item.use_jump_url) {
        window.location.href = item.use_jump_url
      }
      else {
        this.$router.push('/sf/home')
      }
    }
  }
}
</script>
<style lang="less">
  .myvanfield{
    .van-field__label {
      color:#646566 !important;
    }
  }
</style>
<style lang="less" scoped>
  .sfwaitpay{
    width:100%;
    min-height:100vh;
    background-color: #f4f5fb;
    .sp1{
      height:30px;
    }
    .con{
      width:100%;
      background-color:#ffffff;
      margin:0px 15px;
    }
  }
  .searchlist1{
    .item{
      width: 708px;
      height: 199px;
      background-image: url("../../../assets/img/common/couponbg.png");
      background-size:100% 100%;
      background-repeat: no-repeat;
      margin:0px auto 15px auto;
      display:flex;
      .left{
        width:70%;
        .leftin{
          margin:15px;
        }
        .l1{
          padding-top:20px;
          .s1{
            display:inline-block;
            width:93px;
            height:37px;
            font-size: 26px;
            text-align:center;
            line-height:37px;
            background-color:#8dbaf5;
            color:#ffffff;
            border-radius: 4px;
          }
          font-size: 26px;
          color: #333333;
          margin-bottom:15px;
        }
        .l2{
          font-weight: 400;
          font-size: 26px;
          color: #333333;
          margin-bottom:15px;
          height:40px;
          line-height:40px;
        }
        .l3{
          font-weight: 400;
          font-size: 26px;
          color: #333333;
          margin-bottom:15px;
          height:40px;
          line-height:40px;
        }
      }
      .right{
        flex:1;
        text-align:center;
        .r1{
          font-weight: 500;
          font-size: 30px;
          color: #FFFFFF;
          padding-top:40px;
          margin-bottom:15px;
        }
        .r2{
          font-weight: 500;
          font-size: 24px;
          color: #FFFFFF;
          margin-bottom:12px;
        }
        .r3{
          .r3btn{
            width:140px;
            height:45px;
            background-color:#ffffff;
            border-radius: 45px;
            text-aling:center;
            line-height:45px;
            font-size: 26px;
            color:#8dbaf5;
            margin:0px auto;
          }
        }
      }
    }
  }
</style>
